export const CRM_ORIGENES = [
  "Web orgánica",
  "Publicidad online",
  "Redes sociales",
  "Recomendación de cliente",
  "Colaborador o partner",
  "Evento o feria",
  "Prospección comercial",
  "Cartera existente",
  "Aseguradora o mediador",
  "Inteligencia artificial",
  "Otro",
] as const;

export function CrmOrigenSelect({
  value,
  onChange,
  className = "",
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  const isLegacyValue =
    value !== "" &&
    !CRM_ORIGENES.some((origen) => origen === value);

  return (
    <label className={`block ${className}`}>
      <span className="mb-1 block text-sm font-medium text-gray-700">
        Origen
      </span>
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-[#1A3AB8] focus:outline-none focus:ring-2 focus:ring-[#1A3AB8]"
      >
        <option value="">Selecciona un origen</option>
        {isLegacyValue && (
          <option value={value}>{value} (valor anterior)</option>
        )}
        {CRM_ORIGENES.map((origen) => (
          <option key={origen} value={origen}>
            {origen}
          </option>
        ))}
      </select>
    </label>
  );
}
